import React from "react";
import styles from "../../styles/HomePage.module.css";

export default function WhyEarTrainingSection() {
    return (
        <section id="why-ear-training" className={styles.whySection}>
            <h2 className={styles.sectionTitle}>What Ear Training Unlocks</h2>
            <div className={styles.painPoints}>
                <div className={styles.painPoint}>
                    <div className={styles.painIcon}>🎸</div>
                    <h3 className={styles.painTitle}>Play Songs Without Sheet Music</h3>
                    <p className={styles.painDescription}>
                        Hear a melody once and figure out how to play it. No more hunting for tabs
                        or waiting for tutorials - just listen and play.
                    </p>
                </div>
                <div className={styles.painPoint}>
                    <div className={styles.painIcon}>🎤</div>
                    <h3 className={styles.painTitle}>Sing In Tune with Confidence</h3>
                    <p className={styles.painDescription}>
                        Stop second-guessing your pitch. Train your ear to hear when you're on key
                        and develop the control to hit the right notes every time.
                    </p>
                </div>
                <div className={styles.painPoint}>
                    <div className={styles.painIcon}>🎹</div>
                    <h3 className={styles.painTitle}>Understand Music as You Hear It</h3>
                    <p className={styles.painDescription}>
                        Break down songs into their building blocks. Know instantly if that's a major
                        or minor chord, recognize the progression, understand the melody.
                    </p>
                </div>
            </div>
        </section>
    );
}
